<template>
	<!--
<Help :code="'plant-1'" :btnClose="false">
	<div>{{$t('phrase553',['你可以点击这里再次设置'])}}</div>
</Help>
-->
	<button class="helpBtn posR fSub hover-f-main" type="button">
		<icon :name="svgIcon" :sizeBase="'xxs'" class="w2x h2x tra-fast" />
		<div class="tip tra-fast">
			<Icon name="tipArrow" class="arrow sSub tra-fast" />
			<div class="content bdSub boxR" :class="{ 'bdSub-right': btnClose }">
				<div class="cContent" v-html="helpTipMessage(code)" scroll></div>
				<slot :class="{ 'bdSub-right': btnClose }"></slot>
			</div>
			<div v-if="btnClose" class="tableSys w4x">
				<button class="close w4x close-ico bgClose tra-fast" type="button">
					<svg class="w2x h2x fWhite">
						<use xlink:href="#ico-close"></use>
					</svg>
				</button>
			</div>
		</div>
	</button>
</template>
<script>
import { getLanguageStr } from "@/util/language";
import * as lib from "@/util/lib.js";
export default {
	name: "Help",
	components: {},
	props: {
		position: {
			type: String,
			default: "bottom",
		},
		code: {
			type: String,
			default: "",
		},
		btnClose: {
			type: Boolean,
			default: true,
		},
		svgIcon: {
			// svg展示的样子
			type: String,
			default: "unon",
		},
		// addClass:{//激活的索引项
		// 	type:[String,Object],
		// 	default:""
		// },
	},
	data() {
		return {};
	},
	methods: {
		getLanguageStr,
		setPosition: function () {
			this.$nextTick(() => {
				if ($(this.$el).parents("[scroll]").length) {
					//在滚动内采用fixed避免被截掉
					$(this.$el).find(".tip").addClass("fixMode");
					if ($("section").last().scrollTop() > 0) {
						$(this.$el)
							.find(".tip")
							.css({
								top: $(this.$el).offset().top + $(this.$el).height(),
							});
					}
				} else {
					$(this.$el).find(".tip").removeClass("fixMode");
				}
				// 定位
				let space = stage.space;
				let $btn = $(this.$el);
				let $tip = $btn.find(".tip");
				let $arrow = $btn.find(".arrow");
				let $content = $btn.find(".tip .content");
				let left = -$content.innerWidth() / 2;
				let top = "";
				// let fix=$btn.offset().left-left
				// x轴修正
				if ($btn.offset().left + $content.innerWidth() / 2 > $(window).width()) {
					// 超出右边界
					left -= $btn.offset().left + $content.innerWidth() / 2 - $(window).width() + space;
				}
				if (
					$(this.$el).parents(".window-view").length == 0 &&
					$(".sideSys").innerWidth() &&
					$btn.offset().left - $content.innerWidth() / 2 < $(".sideSys").innerWidth()
				) {
					// 详情是全屏的，需要避开
					left += $content.innerWidth() / 2 - $btn.offset().left + $(".sideSys").innerWidth() + space;
				} else if ($btn.offset().left - $content.innerWidth() / 2 < 0) {
					// 超出左边界
					left += $content.innerWidth() / 2 - $btn.offset().left + space;
				}
				// y轴修正
				if ($btn.offset().top + $content.innerHeight() + space * 2 > $(window).height()) {
					top = -$content.innerHeight() - $btn.innerHeight() - space;
					$arrow.addClass("modeDown");
				} else {
					$arrow.removeClass("modeDown");
				}
				$tip.css({
					"margin-top": Math.round(top) || "",
				});
				$content.css({
					"margin-left": Math.round(left) || "",
				});
				lib.setScroll($(this.$el).find("[scroll]"));
				if (this.position === "right") {
					$arrow.removeClass("modeDown");
					$arrow.addClass("modeRight");
					$content.css({
						"margin-left": "2.1em",
						"margin-top": "-2.5em",
					});
				}
			});
		},
		helpTipMessage: function (code) {
			// 根据code返回文本
			switch (code) {
				case "dc_dispersion_rate":
					code = `<div class=''>
					<div>${getLanguageStr("plant421", "直流离散率=各支路直流电流的标准差/各支路直流电流的均值，默认使用当前电站日出后2小时及日落前2小时内的数据计算。")}</div>
					<div class='cSub'>${getLanguageStr("plant422", "如需计算请先在逆变器编辑功能内输入组件容量")}</div>
					</div>`;
					break;
				case "inverter_performance": // 主系统下使用
					code = `<div class='lh20'>
					<div class='fs12x mb05x'>${getLanguageStr("plant414", "逆变器性能")}</div>
					<div><span class='cSuccess'>${getLanguageStr("plant409", "正常")}:</span>${getLanguageStr(
						"plant423",
						"大于或等于当前电站下逆变器的最高当日满发小时的80%"
					)}</div>
					<div><span class='cDanger'>${getLanguageStr("plant410", "偏低")}:</span>${getLanguageStr("plant424", "低于当前电站下逆变器的最高当日满发小时的80%")}</div>
					<div><span class='cError'>${getLanguageStr("plant411", "过低")}:</span>${getLanguageStr("plant425", "低于当前电站下逆变器的最高当日满发小时的50%")}</div>
					<div><span class='cFail'>${getLanguageStr("plant412", "停机")}:</span>${getLanguageStr("plant426", "逆变器当日满发小时=0")}</div>
					<div><span class='cSub'>${getLanguageStr("plant427", "离线逆变器不参与计算")}</div>
					</div>`;
					break;
				case "inverter_performance-childSys": // 子系统下使用
					code = `<div class='lh20'>
					<div class='fs12x mb05x'>${getLanguageStr("plant414", "逆变器性能")}</div>
					<div><span class='cSuccess'>${getLanguageStr("plant409", "正常")}:</span>${getLanguageStr(
						"plant461",
						"大于或等于当前子系统下逆变器的最高当日满发小时的80%"
					)}</div>
					<div><span class='cDanger'>${getLanguageStr("plant410", "偏低")}:</span>${getLanguageStr("plant462", "低于当前子系统下逆变器的最高当日满发小时的80%")}</div>
					<div><span class='cError'>${getLanguageStr("plant411", "过低")}:</span>${getLanguageStr("plant463", "低于当前子系统下逆变器的最高当日满发小时的50%")}</div>
					<div><span class='cFail'>${getLanguageStr("plant412", "停机")}:</span>${getLanguageStr("plant426", "逆变器当日满发小时=0")}</div>
					<div><span class='cSub'>${getLanguageStr("plant427", "离线逆变器不参与计算")}</div>
					</div>`;
					break;
				case "full_power_hours_day":
					code = `<div class=''>
					<div>${getLanguageStr("plant428", "当日满发小时=当日发电量/组件容量")}</div>
					<div class='cSub'>${getLanguageStr("plant422", "如需计算请先在逆变器编辑功能内输入组件容量")}</div>
					</div>`;
					break;
				case "generation_capacity":
					code = `<div class=''>
					<div>${getLanguageStr("plant429", "功率归一化=发电功率/组件容量")}</div>
					<div class='cSub'>${getLanguageStr("plant422", "如需计算请先在逆变器编辑功能内输入组件容量")}</div>
					</div>`;
					break;
				case "installed_capacity":
					code = `<div class=''>
					<div>${getLanguageStr("plant430", "逆变器实际连接的组件额定功率之和，请在逆变器编辑功能内填写")}</div>
					</div>`;
					break;
				case "DAU":
					let date = new Date();
					let incStr = lib.timeFormat(date, "inc", "%Y/%m/%d %H:%M:%S UTC");
					incStr = incStr.substring(0, 11) + "00:00:00" + incStr.substring(incStr.length - 10);
					let mes = i18n.t("com_check45", [incStr, "之后有数据上传记录"]);
					code = `<div>${mes}</div>`;
					break;
				case "MAU":
					let mdate = new Date();
					let mincStr = lib.timeFormat(mdate, "inc", "%Y/%m/%d %H:%M:%S UTC");
					mincStr = mincStr.substring(0, 8) + "01 00:00:00" + mincStr.substring(mincStr.length - 10);
					let mmes = i18n.t("com_check45", [mincStr, "之后有数据上传记录"]);
					code = `<div>${mmes}</div>`;
					break;
				case "YAU":
					let ydate = new Date();
					let yincStr = lib.timeFormat(ydate, "inc", "%Y/%m/%d %H:%M:%S UTC");
					yincStr = yincStr.substring(0, 5) + "01/01 00:00:00" + yincStr.substring(yincStr.length - 10);
					let ymes = i18n.t("com_check45", [yincStr, "之后有数据上传记录"]);
					code = `<div>${ymes}</div>`;
					break;
				case "unassociatedSystem":
					code = `<div>${getLanguageStr("device19", "暂未添加到系统（如电站等）")}</div>`;
					break;
				case "associatedSystem":
					code = `<div>${getLanguageStr("device18", "已添加到系统（如电站等）")}</div>`;
					break;
				case "manfaHours":
					code = `
						<div>
							<div>${getLanguageStr("plant280", "日满发小时=日发电量/装机容量")}</div>
						</div>`;
					break;
				case "powerNormalization":
					code = `
						<div>
							<div>${getLanguageStr("plant_list7", "功率归一化=发电功率/装机容量")}</div>
						</div>`;
					break;
				case "successiveTriggers":
					code = `
						<div>
						<div class="mb05x">${getLanguageStr("word1943", "连续几次触发后推送")}</div>
						<div>${getLanguageStr("message2", "指的是系统会监测电站下每个设备的不同报警的连续触发次数，当达到设置的次数后发出报警消息。以避免连续发送报警消息的情况")}</div>
						</div>`;
					break;
				case "dailyPushLimit":
					code = `<div><div class="mb05x">${getLanguageStr("message3", "每日推送上限")}</div><div>${getLanguageStr(
						"message4",
						"指的是系统会限制电站下每个设备的不同报警每日发出报警消息的上限。以避免报警消息太多导致骚扰接收人的情况。"
					)}</div></div>`;
					break;
				case "reasonFailureDetail":
					code = `<div>
								<div>${getLanguageStr("task71", "指令发送失败：指令未能成功下发，可能是网络问题，建议确认设备正常连接后重发；")}</div>
								<div>${getLanguageStr("task72", "解析结果失败：指令已成功下发，设备未响应或响应结果与预期不符，请查看设备实际数据进行核实；")}</div>
							</div>
							`;
					break;
				case "reasonFailure":
					code = `<div>
									<div>${getLanguageStr("task70", "指令任务冲突：存在其他正在执行的指令，请稍后重试。")}</div>
								<div>${getLanguageStr("task71", "指令发送失败：指令未能成功下发，可能是网络问题，建议确认设备正常连接后重发；")}</div>
								<div>${getLanguageStr("task72", "解析结果失败：指令已成功下发，设备未响应或响应结果与预期不符，请查看设备实际数据进行核实；")}</div>
								<div>${getLanguageStr("task73", "设备不属于该产品：该设备不属于该产品，无法发送指令。")}</div>
								<div>${getLanguageStr("task82", "系统错误：系统错误，指令无法发送。")}</div>
							</div>
							`;
					break;
				case "messageTip":
					code = `<div>
									<div class="fs12x mt1x mb1x">${getLanguageStr("phrase950", "哪些情况下规则不会立即生效？")}</div>
									<div>${getLanguageStr("phrase951", "以下情况规则不会立即生效，最晚在12小时内生效")}</div>
								<div>1.${getLanguageStr("phrase952", "删除接收人的角色")}</div>
								<div>2.${getLanguageStr("phrase953", "接收人所在商家的外部角色被授权方删除")}</div>
								<div>3.${getLanguageStr("phrase954", "修改接收人的角色")}</div>
								<div>4.${getLanguageStr("phrase955", "接收人所在商家的外部角色被授权方修改")}</div>
								<div>5.${getLanguageStr("phrase956", "修改接收人组的层级")}</div>
								<div>6.${getLanguageStr("phrase957", "从商家组下移除接收人")}</div>
								<div>7.${getLanguageStr("phrase958", "修改接收人所属的组")}</div>
								<div>8.${getLanguageStr("phrase959", "将电站的授权关系中移除接收人")}</div>
								<div>9.${getLanguageStr("phrase960", "将电站的授权关系中移除接收人所在商家")}</div>
								<div>10.${getLanguageStr("phrase961", "删除接收人可见的电站")}</div>
								<div>11.${getLanguageStr("phrase962", "新建接收人可见的电站")}</div>
								<div>12.${getLanguageStr("phrase963", "新建用户并将该用户添加到报警消息的接收人")}</div>
							</div>`;
					break;
				case "accessing":
					code = getLanguageStr("phrase864", "电站内没有设备或设备没有往系统发送过数据的情况即为接入中状态。");
					break;
				case "alarming":
					code = getLanguageStr("phrase895", "在电站最近数据更新时收到报警即为有报警状态。");
					break;
				case "plant-1":
					code = getLanguageStr("phrase554", "如果你选择的累计发电量计算方式为通过每日求和，那么你无需再设置累计发电量偏移量，系统将自动计算偏移量。");
					break;
				case "device":
					code = getLanguageStr(
						"phrase643",
						"请确保子设备（如逆变器、电表、组件等）已通电并和直连设备（如采集器）通讯正常，如未找到你想找的直连设备请点击刷新按钮刷新列表。"
					);
					break;
				case "orderUpgrad":
					code = getLanguageStr("phrase629", "当超过超时时间，关联版本信息仍未变化时，将默认升级失败，可再次升级");
					break;
				case "outMer":
					code = `<div>${getLanguageStr("device349", "全部授权：向所有外部商家开放权限")}</div>
					<div>${getLanguageStr("device372", "指定授权：向指定外部商家开放权限；")}</div>`;
					break;
				case "outPer":
					code = `<div>${getLanguageStr("device350", "全部授权：向所有终端用户开放权限；")}</div>
					<div>${getLanguageStr("device373", "指定授权：向指定终端用户开放权限")}</div>`;
					break;
				case "orderControl":
					code = getLanguageStr("phrase628", "超时仍未收到指令反馈将默认发送失败，可再次发送");
					break;
				case "pr":
					code = `<div>${getLanguageStr("phrase996", "昨日PR=昨日发电量/（昨日辐照量*电站装机容量）")}</div><div>${getLanguageStr(
						"phrase997",
						"当前辐照数据源：平均气象站数据"
					)}</div>`;
					break;
				case "startTime":
					code = getLanguageStr("phrase664", "投产日期是电站正常发电的日期，并网电站建议选择并网日期，离网电站建议选择开始发电日期。");
					break;
				case "register":
					code = getLanguageStr(
						'<div><p style="font-weight: bold;">+phrase686+</p>+ phrase687',
						"开始运行日期是电站正常发电的日期，并网 电站建议选择并网日期，离网电站建议选择 开始发电日期。我们将根据该日期统计电站 数据。</div>"
					);
					break;
				case "noSystem":
					code = `<div>
								<div class="fsLv2">${getLanguageStr("phrase841", "什么是子设备")}</div>
								<div class="mb1x fsLv1">${getLanguageStr("phrase836", "网关设备连接的设备为子设备，比如采集器是网关设备，那么逆变器就是子设备。")}</div>
								<div class="fsLv2">${getLanguageStr("phrase837", "什么情况下使用【自动添加子设备】和【手动选择子设备】？")}</div>
								<div class="fsLv1">${getLanguageStr(
									"phrase838",
									"如果你的网关设备仅用于一个电站，那么推荐使用【自动添加子设备】，系统将根据网关设备与子设备的连接情况，自动添加子设备到电站。如果你的网关设备用于多个电站，那么推荐使用【手动选择子设备】，你可以根据每个电站的实际子设备使用情况，选择合适的子设备。"
								)}</div>
								<div class="mb1x fsLv1">${getLanguageStr(
									"phrase643",
									"请确保子设备（如逆变器、电表、组件等）已通电并和网关设备（如采集器）通讯正常，如未找到你想找的网关设备请点击刷新按钮刷新列表。"
								)}</div>
								<div class="fsLv2">${getLanguageStr("phrase839", "为什么我只能使用【手动选择子设备】？")}</div>
								<div class="mb1x fsLv1">${getLanguageStr(
									"phrase840",
									"如果网关设备一开始通过【自动添加子设备】的方式加入到电站，那么系统将不支持再次将网关设备加入到别的电站，所以只有网关设备一开始通过【手动选择子设备】的方式加入到电站才可以再次加入到别的电站。因此，如果你的子设备的添加方式只能为【手动选择子设备】说明该网关设备一开始通过【手动选择子设备】的方式加入到电站。"
								)}</div>
							</div>`;
					break;
				case "dataloggerUpdate":
					code = `<div>
						<div>${getLanguageStr("phrase749", "① GPRS1 (AT+UPURL=47.88.6.171:30005,filename) #原GPRS1, 1期netty服务器")}</div>
						<div>${getLanguageStr(
							"phrase750",
							"② GPRS2 (AT+UPDATE=214028,10,http://198.11.174.215:30004/filepath,filename) #原GPRS2和GPRS3通用版, 通用HTTP文件服务器"
						)}</div>
						<div>${getLanguageStr("phrase751", "③ WIFI (AT+UPURL=http://198.11.174.215:30004/file_path_name) #原WIFI, 通用HTTP文件服务器")}</div>
						<div>${getLanguageStr("phrase752", "④ 以太网 (AT+UPDATE=214028,0,http://198.11.174.215:30004/,file_path_name) #原以太网, 通用HTTP文件服务器")}</div>
						<div>${getLanguageStr("phrase753", "⑤ GPRS21 (AT+UPDATE=214028,10,http://198.11.174.215:18021/,filename) #原GPRS2和GPRS3特定版本, 定制nginx服务器")}</div>
						<div>${getLanguageStr("phrase754", "⑥ CDMA (暂未上线)")}</div>
						</div>`;
					break;
				case "deviceUpdate":
					code = `<div>
						<div>${getLanguageStr("phrase755", "① GPRS1 (AT+INVUPURL=47.88.6.171:21,power,QdTrQB7,/,filename) #原GPRS1通用版, 通用FTP文件服务器")}</div>
						<div>${getLanguageStr("phrase756", "② GPRS2 (AT+UPDATE=214028,20,http://198.11.174.215:30004/filepath,filename) #原GPRS2通用版, 通用HTTP文件服务器")}</div>
						<div>${getLanguageStr("phrase757", "③ GPRS3 (AT+FTPUPURL=47.88.6.171:21,power,QdTrQB7,/,filename) #原GPRS3, 通用FTP文件服务器")}</div>
						<div>${getLanguageStr("phrase758", "④ WIFI (AT+INVUPURL=http://198.11.174.215:30004/)  #原WIFI, 通用HTTP文件服务器")}</div>
						<div>${getLanguageStr("phrase759", "⑤ 以太网 (AT+UPDATE=214028,1,http://198.11.174.215:30004/,file_path_name)  #原以太网, 通用HTTP文件服务器")}</div>
						<div>${getLanguageStr("phrase760", "⑥ 通用FTP (AT+SFTPUPURL=47.88.6.171:21,power,QdTrQB7,/,file_name,2,crc) #原通用FTP, 通用FTP文件服务器")}</div>
						<div>${getLanguageStr(
							"phrase761",
							"⑦ 通用HTTP (AT+SUPDATE=214028,http://198.11.174.215:30004/file_path/,file_name,2,crc) #原通用HTTP, 通用HTTP文件服务器"
						)}</div>
						<div>${getLanguageStr("phrase762", "⑧ GPRS11 (AT+INVUPURL=47.88.6.171:30005,filename) #原GPRS1特定版本, 1期netty服务器")}</div>
						<div>${getLanguageStr("phrase763", "⑨ GPRS21 (AT+UPDATE=214028,20,http://198.11.174.215:18021/,filename) #原GPRS2特定版本, 定制nginx服务器")}</div>
						<div>${getLanguageStr("phrase764", "⑩ CDMA")}</div>
					</div>`;
					break;
				case "inspectLevel":
					code = `<div>
						<div>${i18n.t("diagnosis39", ["A", "A级"]) + ": " + getLanguageStr("diagnosis40", "未发现电站异常与设备故障")}</div>
						<div>${i18n.t("diagnosis39", ["B", "B级"]) + ": " + getLanguageStr("diagnosis41", "电站可能存在故障，需要继续观察")}</div>
						<div>${i18n.t("diagnosis39", ["C", "C级"]) + ": " + getLanguageStr("diagnosis42", "电站数据质量存在问题，不足以判断电站状态")}</div>
						<div>${i18n.t("diagnosis39", ["D", "D级"]) + ": " + getLanguageStr("diagnosis43", "设备出现故障且影响电站发电")}</div>
						<div>${i18n.t("diagnosis39", ["E", "E级"]) + ": " + getLanguageStr("diagnosis44", "电站存在安全隐患")}</div>
						</div>`;
					break;
				case "powerSuport":
					code = `<div>
						<div style='padding:0 0 1rem 0'>${getLanguageStr("光伏发电基准指数支持哪些城市？", "光伏发电基准指数支持哪些城市？")}</div>
						<div style='padding:0 0 1rem 0'><span style='font-weight: bold'>安徽： </span><span> 安庆  豪州 池州</span></div>
					<div style='padding:0 0 1rem 0'><span style='font-weight: bold'>江苏： </span><span> 常州 淮安 连云港 南京 南通 苏州 宿迁 泰州 无锡 徐州</span></div>
						</div>`;
					break;
				case "planStartTime":
					code = `<div>
						${getLanguageStr(
							"ticket191",
							"该时间为第一个工单计划开始和结束的时间，第一个工单一般提前开始时间24小时生成，如果该时间在未来24小时内，那么在提交计划后的1分钟内立刻生成第一个工单。"
						)}
						</div>`;
					break;
				case "alert-timeFilter-current":
					code = `<div>
						<div>${getLanguageStr("word1454", "当前")}</div>
						<div class="mt05x">${getLanguageStr("phrase784", "当前指的最近数据更新时间，在电站最近数据更新时收到报警即为有报警状态。")}</div>
						</div>`;
					break;
				case "alert-timeFilter-current-device":
					code = `<div>
						<div>${getLanguageStr("word1454", "当前")}</div>
						<div class="mt05x">${getLanguageStr("device245", "当前是指最近一次数据更新时间")}</div>
						</div>`;
					break;
				case "LayoutDownload":
					code = `<div>
						<div class="fs12x">${getLanguageStr("phrase942", "布局信息该怎么填？")}</div>
						<div class="fs10x;mt1x" style='font-size:10px;margin-top:1rem'>
						<div style='margin-bottom:.5rem'>${getLanguageStr("phrase945", "以下是布局信息填写示例")}</div>
							<table class="bdSub-right bdSub-bottom">
								<tr>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>${getLanguageStr("word648", "组件SN")}</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>${getLanguageStr("word1643", "坐标")}X</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>${getLanguageStr("word1643", "坐标")}Y</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>${getLanguageStr("word1115", "组串")}</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>${getLanguageStr("word1116", "编号")}</td>
								</tr>
								<tr>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>123456789-1</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>1</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>1</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>1</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>1</td>
								</tr>
								<tr>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>123456789-2</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>1</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>2</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>1</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>2</td>
								</tr>
								<tr>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>123456789-3</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>3</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>3</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>1</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>3</td>
								</tr>
								<tr>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>123456789-4</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>4</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>4</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>1</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>4</td>
								</tr>
								<tr>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>123456780-1</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>5</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>5</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>2</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>1</td>
								</tr>
								<tr>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>123456780-2</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>6</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>6</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>2</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>2</td>
								</tr>
								<tr>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>123456780-3</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>7</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>7</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>2</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>3</td>
								</tr>
								<tr>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>123456780-4</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>8</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>8</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>2</td>
									<td style='border-left:1px solid #909090;border-top:1px solid #909090'>4</td>
								</tr>
							</table>
							<p style='margin-top:1rem'>${getLanguageStr("phrase946", "1.坐标X和Y仅支持正整数，不包括0和负数")}</p>
							<p>${getLanguageStr("phrase947", "2.坐标X和Y组合起来不可重复，比如不允许都为（1，1）")}</p>
							<p>${getLanguageStr("phrase948", "3.组串和编号信息可不填，如果填写，那么相同的组串号对应的编号必须从1开始且连续")}</p>
						</div>
					</div>
					`;
					break;
				case "full_power_hours_day1":
					code = `<div>${getLanguageStr("plant_list6", "当日满发小时=当日发电量/装机容量")}</div>`;
					break;
				case "allforone":
					code = `<div>${getLanguageStr("plant_list7", "功率归一化=发电功率/装机容量")}</div>`;
					break;
				case "pr_yesterday":
					code = `<div>${getLanguageStr("plant_list65", "昨日PR=昨日发电量/（昨日辐照量*电站装机容量）")}</div>`;
					break;
				case "senorcode":
					code = `<div>${getLanguageStr("product8", "协议代号")}</div>`;
					break;
				case "radiation":
					code = `<div>${getLanguageStr("device262", "如果逆变器所属电站有辐照强度数据，将默认填充，如果没有，请手动填写。")}</div>`;
					break;
				case "Ivtemp":
					code = `<div>${getLanguageStr("device322", "如果逆变器所属电站有当地温度数据，将默认填充，如果没有，请手动填写。")}</div>`;
					break;
				case "timeoutStatus":
					code = `<div>${getLanguageStr("ticket131", "处理人未按未按计划开始处理工单且超出计划开始时间30分钟以上或实际开始时间比计划开始时间晚的情况")}</div>`;
					break;
				case "offset":
					code = `<div>${getLanguageStr("ticket137", "实际用时与计划用时的偏差")},${getLanguageStr("ticket138", "实际用时越少偏差越小")}</div>`;
					break;
				case "myWorkOrder":
					code = `<div>${getLanguageStr(
						"manage411",
						"本人的工单本人的工单指的是工单流程中涉及的所有相关人员的工单，包含发起人、处理人、验证人、抄送人、评价人等"
					)}</div>`;
					break;
				case "workingState":
					code = `<div style='margin:0 0 0 0 ;padding:0 0 0 0;'>${getLanguageStr("ticket175", "空闲：该人员无“执行中”工单")}</div><div>${getLanguageStr(
						"ticket176",
						"工作中：该人员有“执行中”工单"
					)}</div>`;
					break;
			}
			return code;
		},
	},
	created() {},
	mounted() {
		$(this.$el).on("mouseenter", this.setPosition);
		if ($(this.$el).parents(".window-alert").length > 0) {
			$(this.$el).find(".tip").css("position", "fixed");
		}
		// lib.setScroll($(this.$el).find('.content[scroll]'))
		// this.$nextTick(() => {
		// 	this.setPosition();
		// });
	},
};
</script>
<style lang="scss" scoped>
[class*="leave-active"] svg {
	display: none;
	width: 0;
	opacity: 0;
}
.tip {
	position: absolute;
	z-index: 5;
	width: fit-content;
	pointer-events: none;
	opacity: 0;
	transition-property: opacity, visibility;
	margin: {
		top: 0.7em;
	}
	.content {
		width: max-content;
		max-width: 36em;
		padding: 0.5em 1em;
		line-height: 1.4;
		text-align: left;
		background-color: $contentBgColor;
		box-shadow: 0.2em 0.2em 1em rgba(#000, 0.2);
		[scroll] {
			max-height: 20em;
		}
	}
}
.helpBtn {
	z-index: 2;
	.arrow {
		position: absolute;
		top: -1.3em;
		display: block;
		width: 2em;
		height: 2em;
		padding: 0;
		pointer-events: none;
		opacity: 0;
		transform: rotate(180deg); //margin:{left:-.1em;};left:50%;border-left:.5em solid $alpha;border-right:.5em solid $alpha;border-bottom:.5em solid $neutral;
		margin: {
			left: -0.5em;
		}
		&.modeDown {
			top: unset;
			bottom: -0.8em;
			transform: rotate(0);
		}
		&.modeRight {
			top: -2em;
			right: unset;
			bottom: -0.8em;
			left: 1em;
			transform: rotate(90deg);
		}
	}
	&:hover,
	&:focus,
	&:active {
		.arrow,
		.tip {
			pointer-events: auto;
			opacity: 1;
		}
	}
	.close {
		position: absolute;
		height: 100%;
	}
}
.fixMode {
	position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Help.vue